import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Feed } from "src/components";
import { CommentSubject } from "src/constants";
import { useSignalR } from "src/hooks";
import { queryKeys, useGetTaskItemFeed } from "src/http";

interface IProps {
  taskItemGuid: string;
}

const TaskItemFeed = (props: IProps) => {
  const { isLoading, data } = useGetTaskItemFeed(props.taskItemGuid);
  const queryClient = useQueryClient();
  const signalR = useSignalR();

  useEffect(() => {
    const handleShouldRefetchComments = (taskItemGuid: string) => {
      queryClient.invalidateQueries(queryKeys.taskItems.getTaskItemFeed(taskItemGuid));
    };

    signalR.onShouldRefetchComments(handleShouldRefetchComments);
    return () => signalR.offShouldRefetchComments(handleShouldRefetchComments);
  }, [queryClient, signalR]);

  return (
    <Feed
      subjectType={CommentSubject.TaskItem}
      subjectGuid={props.taskItemGuid}
      isLoading={isLoading}
      items={data?.feed ?? []}
      onCommentCreated={() => signalR.sendRefetchTaskItem(props.taskItemGuid)}
      onCommentDeleted={() => signalR.sendRefetchTaskItem(props.taskItemGuid)}
    />
  );
};

export { TaskItemFeed };
